import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Request from "common/Request";
import Result from "./Result";
import { parseThroughputUsage } from "./api.js";
import ActionsContext from "common/ActionsContext";
import BqnContext from "common/BqnContext";
import ThroughputStatusHelp from "./Help";
import { Header } from "common/Header";

const ViewContainer = styled.div`
  min-height: 50vh;
  &.card {
    height: 100%;
  }
`;

const ContextMenu = () => {
  const actions = useContext(ActionsContext);
  return (
    <ul className="context-menu header-dropdown m-r--5">
      <li>
        <a
          data-loading-effect="pulse"
          data-toggle="cardloading"
          title="Help"
          onClick={() => actions.send("open-help")}
        >
          <i className="material-icons">help_outline</i>
        </a>
        <a
          onClick={() => {
            actions.send("do-load");
          }}
          data-toggle="cardloading"
          data-loading-effect="pulse"
          title="Refresh"
        >
          <i className="material-icons">refresh</i>
        </a>
      </li>
    </ul>
  );
};

export const cpuUsageRetrieval = (mode, bqnId) =>
  ifCl
    .run("show interface pkteng bandwidth")
    .then((response) => ({usage: parseThroughputUsage(response, mode, bqnId)}))

const ThroughputStatus = () => {
  const {
    clusterStatus: { mode },
    bqnId,
  } = useContext(BqnContext);
  const actions = useContext(ActionsContext);
  const [request, setRequest] = useState(null);

  const doLoad = () => {
    setRequest(() => cpuUsageRetrieval(mode, bqnId));
  };

  useEffect(() => doLoad() || actions.recv("do-load", doLoad), []);

  return (
    <ViewContainer className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div className="card">
        <Header
          title="Current Network Interface Throughput"
          contextMenu={<ContextMenu />}
          bqnSelector={true}
        />
        <div className="body flex-panel-column">
          <Request during={request}>
            {(response) => <Result {...response} />}
          </Request>
        </div>
      </div>
      <ThroughputStatusHelp />
    </ViewContainer>
  );
};

export default ThroughputStatus;
